export enum FollowUpStudyCompletionReadOnlyReason {
	StageNotEditable = "STAGE_NOT_EDITABLE",
	NotAssignedStudyEmployee = "NOT_ASSIGNED_STUDY_EMPLOYEE",
	CompletionRequestClosed = "COMPLETION_REQUEST_CLOSED",
}
